let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7v2o1")).then(() => parcelRequire('60Z0d'));